import { theme } from 'antd';
import { smallTimeOptions } from 'assets/styles/constants';
import { getAccessData } from 'library/helpers/accessControl';
import WithHyperLink from 'library/hoc/withHyperLink';
import { uniqBy } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Table, Typography } from 'zui/Antd';

const { Text } = Typography;

const RenderGroupPermissions = ({ groupID }) => {
	const {
		remoteConfig: { constants, accessControlPermissionType }
	} = useSelector((state) => state.FbRemoteConfig);

	const {
		token: { fontWeightStrong }
	} = theme.useToken();

	const [teamAccessData, setTeamAccessData] = useState([]);
	const [loading, setLoading] = useState(false);

	const NameWithLink = WithHyperLink((a) => {
		return (
			<Text
				style={{
					fontWeight: fontWeightStrong
				}}
			>
				{a.children}
			</Text>
		);
	});

	const getData = useCallback(async () => {
		const res = await getAccessData({ assetGroupID: groupID });
		setTeamAccessData(res);
		setLoading(false);
	}, [groupID]);

	useEffect(() => {
		setLoading(true);
		getData();
	}, [getData]);

	const getTextGroup = (text) => {
		return <Text>{accessControlPermissionType[text].shortTitle}</Text>;
	};

	const getName = (data) => {
		return (
			<NameWithLink
				dataID={data.entityID}
				type={data.entityTypeID === constants.ENTITY_TYPE_ID_PERSON ? 'person' : 'team'}
			>
				{data.entityTypeID === constants.ENTITY_TYPE_ID_PERSON ? data.person.displayName : data.team.name}
			</NameWithLink>
		);
	};

	const columns = [
		{
			title: 'Name',
			dataIndex: 'entityID',
			key: 'entityID',
			ellipsis: true,
			render: (_text, record) => {
				return getName(record);
			},
			filters: uniqBy(
				teamAccessData.map((data) => data),
				'name'
			).map((team) => ({
				text: team.name,
				value: team.entityID
			})),
			onFilter: (value, record) => record.entityID === value,
			filterSearch: true
		},
		{
			title: 'Permission',
			dataIndex: 'permissionTypeID',
			key: 'permissionTypeID',
			ellipsis: true,
			sorter: (a, b) => a.permissionTypeID - b.permissionTypeID,
			render: (text) => {
				return getTextGroup(text);
			}
		},
		{
			title: 'Type',
			dataIndex: ['entityType', 'name'],
			key: 'entityTypeName',
			ellipsis: true,
			sorter: (a, b) => a.entityType.name.length - b.entityType.name.length
		},
		{
			title: 'Granted On',
			dataIndex: 'createdDate',
			key: 'createdDate',
			ellipsis: true,
			render: (text) => {
				return <Text title={text}>{new Date(text).toLocaleString('en-AU', smallTimeOptions)}</Text>;
			}
		}
	];

	return (
		<Table
			columns={columns}
			pageSize={10}
			dataSource={teamAccessData}
			filterColumn={['entityID']}
			placeholder='Entity Type or Permission'
			loading={loading}
		/>
	);
};

export default RenderGroupPermissions;
